import { useCandidateInfoQuery } from "@generated/graphql";
import { Stack } from "@mui/material";
import BackPageButton from "components/buttons/BackPageButton";
import CircularLoading from "components/CircularLoading";
import ROUTES from "constants/routes";
import useIsCreate from "hooks/useIsCreate";
import { useParams } from "react-router-dom";
import Content from "./components/Content";
import Header from "./components/Header";
import TrialList from "./components/TrialList";

const CandidateView = () => {
  const isCreate = useIsCreate();
  const { candidateId } = useParams();
  const { data, refetch, loading } = useCandidateInfoQuery({
    variables: { candidateId: candidateId! },
    skip: !candidateId,
  });
  const companyCandidate = data?.companyCandidate;

  if (loading || (!companyCandidate && !isCreate)) return <CircularLoading />;

  return (
    <>
      <BackPageButton
        defaultValue={{
          text: "Список кандидатов",
          link: `/${ROUTES.CANDIDATE}`,
        }}
      />
      <Stack spacing={2.5}>
        <Header />
        <Content
          refetch={refetch}
          companyCandidate={companyCandidate}
        />
        {!isCreate && <TrialList />}
      </Stack>
    </>
  );
};

export default CandidateView;
